/**
 * Ortak arama alaka düzeyi (relevance) yardımcıları.
 *
 * Kural: "harf -> rakam" geçişindeki boşluk farkını tolere ederiz
 * (örn. "vn 50" araması "VN50" ürününü bulsun), ama "rakam -> harf"
 * geçişini ASLA tolere etmeyiz (örn. "cbr 250" araması "CBR 250R"
 * ürününü bulmasın; R farklı bir model eki kabul edilir).
 */
window.SearchRelevance = (function () {
  function normalizeTokens(text) {
    return (text || '')
      .toLocaleLowerCase('tr')
      .replace(/([a-zçğıöşü])(\d)/gi, '$1 $2')
      .split(/[^a-z0-9çğıöşü]+/i)
      .filter(Boolean);
  }

  function normalizeQueryTokens(text) {
    return (text || '')
      .toLocaleLowerCase('tr')
      .split(/[^a-z0-9çğıöşü]+/i)
      .filter(Boolean);
  }

  function matches(title, query) {
    const titleTokens = normalizeTokens(title);
    const queryTokens = normalizeQueryTokens(query);
    if (!queryTokens.length) return true;

    for (let i = 0; i <= titleTokens.length - queryTokens.length; i++) {
      let ok = true;
      for (let j = 0; j < queryTokens.length; j++) {
        if (titleTokens[i + j] !== queryTokens[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return true;
    }
    return false;
  }

  function buildSmartQuery(rawQuery) {
    const trimmed = (rawQuery || '').trim();
    if (!trimmed) return trimmed;
    const concatenated = trimmed.replace(/\s+/g, '');
    if (concatenated.toLowerCase() === trimmed.toLowerCase()) {
      return `"${trimmed}"`;
    }
    return `"${trimmed}" OR ${concatenated}`;
  }

  return { matches, buildSmartQuery };
})();

(function () {
  var params = new URLSearchParams(window.location.search);
  var rawQuery = params.get('oq');
  if (!rawQuery) return;

  document.querySelectorAll('input[type="search"][name="q"]').forEach(function (input) {
    input.value = rawQuery;
  });
})();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.input.form.addEventListener('submit', this.wrapQueryInQuotes.bind(this));
    }
  }

  wrapQueryInQuotes() {
    const raw = this.input.value.trim();
    if (!raw.length) return;

    let rawField = this.input.form.querySelector('input[name="oq"]');
    if (!rawField) {
      rawField = document.createElement('input');
      rawField.type = 'hidden';
      rawField.name = 'oq';
      this.input.form.appendChild(rawField);
    }
    rawField.value = raw;

    const smartQuery = window.SearchRelevance ? window.SearchRelevance.buildSmartQuery(raw) : raw;

    let smartField = this.input.form.querySelector('input[name="q"].search-form__smart-query');
    if (!smartField) {
      smartField = document.createElement('input');
      smartField.type = 'hidden';
      smartField.name = 'q';
      smartField.className = 'search-form__smart-query';
      this.input.form.appendChild(smartField);
    }
    smartField.value = smartQuery;

    this.input.removeAttribute('name');
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
